import type { IslandActivity, IslandMode, IslandNotification } from './IslandProvider';

/** Resting mode: 'live' if jobs are still running, else 'idle'. */
export function resting(activities: IslandActivity[]): IslandMode {
  return activities.some((a) => a.status === 'running') ? 'live' : 'idle';
}

/** Ruhezustand nach dem Schließen: eine noch laufende Anrufkarte hat Vorrang
 *  vor idle/live — sonst geht ein Anruf verloren, der eintraf, während jemand
 *  ein Formular ausfüllte. Erledigte Karten (beendet/verpasst) blenden dagegen
 *  aus, statt nachträglich aufzupoppen. */
/**
 * Darf die Anrufkarte die Pille in den Vordergrund holen?
 *
 * Vorfall 13.08.2026: Die Karte kam bei jedem Ereignis wieder nach vorn — beim
 * Klingeln, beim Abnehmen, beim Auflegen und zusätzlich bei jedem Seitenwechsel
 * (dort wurde der Ruhezustand neu berechnet und fiel auf 'anruf' zurück, solange
 * ein laufendes Gespräch im Zustand stand). Im Alltag verdeckte sie damit dauernd
 * die Arbeitsfläche.
 *
 * Neue Regel: Ein Anruf holt die Pille GENAU EINMAL nach vorn — beim ersten
 * Ereignis seiner ID. Alle weiteren Ereignisse desselben Anrufs aktualisieren die
 * Karte nur noch still. Ein offenes Formular oder Deck unterbricht sie wie bisher nie.
 */
export function darfAnrufAufreissen(
  mode: IslandMode,
  gezeigteAnrufId: string | null,
  neueAnrufId: string,
): boolean {
  if (mode === 'form' || mode === 'deck') return false;
  return gezeigteAnrufId !== neueAnrufId;
}

/** Persistente (server) Einträge ersetzen, Session-Toasts behalten, nach Zeit
 *  sortieren, auf 50 kappen. */
export function mergeServerNotifications(
  current: IslandNotification[],
  items: IslandNotification[],
): IslandNotification[] {
  const session = current.filter((n) => n.source !== 'server');
  return [...items, ...session].sort((a, b) => b.at - a.at).slice(0, 50);
}

/** Aktivitäts-Pille: der zuletzt gestartete laufende Vorgang, sonst der zuletzt beendete (bleibt kurz stehen). */
export function anzuzeigendeAktivitaet<T extends { status: string }>(aktivitaeten: readonly T[]): T | null {
  return [...aktivitaeten].reverse().find(a => a.status === 'running') ?? aktivitaeten[aktivitaeten.length - 1] ?? null;
}
